window.addEventListener('load', () => {
    const blockNumber = document.querySelectorAll('.spcfx-vetement-slider');
    const arrowLeft = document.querySelectorAll('.spcfx-vetement-slider .block-image > .arrow-left');
    const arrowRight = document.querySelectorAll('.spcfx-vetement-slider .block-image > .arrow-right');
    
    for (let i = 0; i < blockNumber.length; i++) {
        const parent = arrowLeft[i].closest('.spcfx-vetement-slider');
        const images = parent.querySelectorAll('.block-image > img');

        let left = 0;
        let maxLeft = (images.length-1)*-100;

        arrowLeft[i].addEventListener('click', () => {
            if (left == 0) {
                left = maxLeft;
            } else {
                left+=100;
            }
            if (left <= 0) {
                for (let i = 0; i < images.length; i++) {
                    images[i].style.left = left + "%";
                }
            }
        });
        
        arrowRight[i].addEventListener('click', () => {
            if (left == maxLeft) {
                left = 0;
            } else {
                left-=100;
            }
            if (left >= maxLeft) {
                for (let i = 0; i < images.length; i++) {
                    images[i].style.left = left + "%";
                }
            }
        });
    }
});